import React, { useState, useEffect } from "react";
import PostGallery from "../../components/utilities/PostGallery";
import { useParams } from "react-router";
import { Box, Container, Grid, Typography, useTheme } from "@mui/material";
import TagCard from "../../components/layout/TagCard";
import ModalLoadingFull from "../../components/modals/ModalLoadingFull";
import { postNotification } from "../../components/utilities/Notifications";
import { getData } from "../../components/utilities/UtilityFunctions";
import { getEnvironmentVariable } from "../../global/environmentVariables";

export default function News() {
  const { tag } = useParams();
  const [loading, setLoading] = useState(true);
  const [tagCards, setTagCards] = useState(null);
  const [tagCard, setTagCard] = useState(null);

  const theme = useTheme();

  useEffect(() => {
    const go = async () => {
      try {
        if (tag) {
          let apiTag = await getData(`/pages/tags/${tag}`, {
            queryStringParameters: {
              env: getEnvironmentVariable("COMPANY_FLAG"),
              "expand[]": ["image"],
            },
          });

          if (apiTag) {
            setTagCard(apiTag);
          }
        } else {
          let queryStringParameters = {
            env: getEnvironmentVariable("COMPANY_FLAG"),
            isPrimaryTag: true,
            "expand[]": ["image"],
          };

          let apiTags = await getData("/pages/tags", {
            queryStringParameters: queryStringParameters,
          });

          if (apiTags) {
            setTagCards(apiTags.data);
          }
        }
      } catch (err) {
        postNotification("error", err);
      }
      setLoading(false);
    };

    go();
    // eslint-disable-next-line
  }, []);

  return (
    <Box width="100%">
      <Container
        maxWidth="lg"
        sx={{
          pt: 2,
          pb: 2,
        }}
      >
        {Boolean(loading) ? (
          <ModalLoadingFull />
        ) : (
          <Grid container gap={2} alignItems="center" sx={{ p: 2 }}>
            <Grid item p={2} xs={12}>
              <Typography
                variant="h3"
                component="a"
                href="/news"
                sx={{
                  color: theme?.palette?.text?.primary,
                }}
              >
                News{tagCard?.title ? `: ${tagCard?.title}` : ""}
              </Typography>
            </Grid>

            {tag || !tagCards ? (
              <></>
            ) : (
              <Grid item p={2} xs={12}>
                <Grid container>
                  {tagCards?.length > 0 &&
                    tagCards.map((tag, index) => {
                      return (
                        <Grid key={index} item p={0.5} xs={12} sm={6} md={4}>
                          <TagCard tag={tag} key={index} />
                        </Grid>
                      );
                    })}
                </Grid>
              </Grid>
            )}

            <Grid item xs={12} sx={{ p: 2 }}>
              <PostGallery tag={tag} doPaging doSearch />
            </Grid>
          </Grid>
        )}
      </Container>
    </Box>
  );
}
